import { casOpsApi, CollectionModel, QueryTag, TagList } from '../api';
import { ModelWithId } from './commonModels';

export interface LibraryItemModel extends ModelWithId {
  ty: number; // Library Item Type ID.
  v: string; // Version
  used: boolean; // Referenced by a package in a configuration group.
  totF: number; // Total number of references (don't need to display this).
}

export const libraryApi = casOpsApi.injectEndpoints({
  endpoints: build => ({
    getListLibrary: build.query<LibraryItemModel[], void>({
      query: () => 'api/library',
      providesTags: (result, error, arg) =>
        result ? [{ type: QueryTag.LibraryItem, id: TagList }] : [],
      transformResponse: ({ items }: CollectionModel<LibraryItemModel>, meta, arg) => items,
    }),
    deleteLibraryItem: build.mutation<void, ModelWithId>({
      query: ({ id }) => ({
        url: `api/library/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { id }) =>
        !error
          ? [
              { type: QueryTag.LibraryItem, id: TagList },
              { type: QueryTag.LibraryItem, id: id },
            ]
          : [],
    }),
  }),
  overrideExisting: false,
});

export const { useGetListLibraryQuery, useDeleteLibraryItemMutation } = libraryApi;
